<!-- Совмещает назначенные машины и водителей заказа в одной табличной ячейке. -->
<template>
  <div class="order-transport-crew-cell">
    <div v-if="vehicles.length" class="order-transport-crew-cell__group">
      <VehicleEntityLink
        v-for="vehicle in vehicles"
        :key="vehicle.id"
        :vehicle="vehicle"
      />
    </div>
    <div v-if="drivers.length" class="order-transport-crew-cell__group">
      <DriverEntityLink
        v-for="driver in drivers"
        :key="driver.id"
        :driver="driver"
        compact
        new-tab
      />
    </div>
    <span v-if="!vehicles.length && !drivers.length" class="order-transport-crew-cell__empty">—</span>
  </div>
</template>

<script>
import DriverEntityLink from "@/components/Driver/DriverEntityLink.vue";
import VehicleEntityLink from "@/components/Vehicle/VehicleEntityLink.vue";

export default {
  name: "OrderTransportCrewCell",

  components: {
    DriverEntityLink,
    VehicleEntityLink,
  },

  props: {
    value: { type: Object, default: null },
  },

  computed: {
    vehicles() {
      return this.value?.vehicles || [];
    },
    drivers() {
      return this.value?.drivers || [];
    },
  },
};
</script>

<style scoped>
.order-transport-crew-cell,
.order-transport-crew-cell__group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.order-transport-crew-cell {
  gap: 6px;
}

.order-transport-crew-cell__group {
  gap: 3px;
}

.order-transport-crew-cell__empty {
  color: #6b7280;
  font-size: 11px;
}
</style>
